export default {
  solutionRow1: '杰为工业软件为制造商提供了一条可以加速数字化转型的道路。利用现代技术优势从新构建的以业务为导向的解决方案，为我们的客户提供可度量的结果和长期价值。杰为解决方案巧妙地设计为可独立运行或与现有系统集成，包括首个真正的实时数字化链。杰为解决方案将赋能我们的客户引领数字创新之路。',
  solutionRow2: '优质的客户体验',
  solutionRow3: '更长久，更深入',
  solutionRow4: '一项关键的竞争点也逐渐显山露水，提供C2M客户体验的产品才能占领高地。然而，市面上的产品基本无法及时将有用的客户数据和偏好输入传统PLM、ERP和供应链系统中，亦无法从中删除。',
  solutionRow5: '尽管制造技术强调提高效率，降低成本，但同时也加剧了行业竞争，使客户不再满足于仅具有功能及质量优势的产品，杰为云平台帮助客户有序介入产品开发过程，并对客户数据进行更深层分析，加深数据了解。制造商能够准确快速交付产品，与客户建立更长久深入的友好合作。',
  solutionRow6: '',
  solutionRow7: '结合客户需求数据与实时分析，了解并预测客户需求',
  solutionRow8: '优化决策流程，让个性化产品与大规模定制生产可实现盈利',
  solutionRow9: '自动优化生产的变更，加快交付，降低成本',
  solutionRow10: '杰为智能数字化链自动解锁复杂的生产关系，挖掘新客户，维稳老客户，搭建与终端客户沟通合作的桥梁。',

  solutionRow11: '供应链实时优化',
  solutionRow12: '每一步可见，每一步可预见',
  solutionRow13: '原始设备制造商需要实时监控所有相关数据，包括质量、产能、库存、交货计划等。无论供应商处在价值链中哪一段，都必须足够灵活，低成本运行，且易于协作。',
  solutionRow14: '随着供应链向虚拟工厂的转化，供应商合多为一，客户对供应链的可见度、透明性及信息实施流通的需求大幅提升，杰为数字化链将现代应用程序与传统产品链接起来，使整个供应链中的参与者能够交换信息，共同协作，基于实时数据输出优质决策。',
  solutionRow15: '',
  solutionRow16: '抓取过程数据并进行供应链中复杂关系的实时分析',
  solutionRow17: '了解每个决策对交付、成本、质量和其他方面的下游影响',
  solutionRow18: '尽量减少潜在的质量、交付及成本风险，避免可能的问题',
  solutionRow19: '杰为基于云的方案可以轻松支持不同规模不同复杂程度的供应商，无需巨额投资，极大简化了OEM及供应商开发流程，并提高双方的盈利能力。',

  solutionRow20: '赋能最优决策',
  solutionRow21: '全面实时协作，更快更优决策',
  solutionRow22: '从设计到制造，不同专业知识糅合，不同角色汇集，团队协作分工明晰，在这个过程中，通讯中断、信息丢失或协作不当等都会引发问题。',
  solutionRow23: '制造商需要找到解决方案来消除数据孤岛，促进团队毫不费力地协作，确保在正确时间将正确的信息传递给正确的人，不论这些人处在价值链的哪一个位置。杰为提供了一种全新的更有价值的数字化链，解锁整个链条中的复杂关系和依赖关系，以人工不可能达到的速度做出智能推荐。',
  solutionRow24: '',
  solutionRow25: '在正确的时间向正确的人提供正确的可操作信息',
  solutionRow26: '产品开发阶段亦或价值链中任一环，实时协作无处不在',
  solutionRow27: '更快更优决策，贯穿设计、研发、制造。',
  solutionRow28: '数字化的洞察力和决策数据还为杰为机器学习引擎提供了宝贵的再训练数据，进而持续改善成本、质量和生产调度。',

  solutionRow29: '研发制造双管齐下',
  solutionRow30: '一般的成本，非一般的速度',
  solutionRow31: '研发制造同时进行有很多优势，如缩短产品开发时间，提高质量，降低成本，这几点虽然为人熟知，但实现难度大，需要采用多领域协作的技术，并具有将问题掐在苗头时的能力，这两点的重要性在复杂价值链中尤为突出，当不同公司成员必须为一致决策努力时，技术与能力缺一不可。',
  solutionRow32: '要实现研发制造双管齐下，就必须采用多领域协作的技术，并具有将问题掐在苗头时的能力，这两点的重要性在复杂价值链中尤为突出，当不同公司成员必须为一致决策努力时，技术与能力缺一不可。',
  solutionRow33: '杰为的实时数字化链与云原生架构助力协作，加速问题处理进程，方便包括供应商在内的所有团队成员。',
  solutionRow34: '实时安全地了解当前工作',
  solutionRow35: '轻松访问相关信息，涵盖产品、零件、成本、质量和过程',
  solutionRow36: '自动分解信息，了解决策、行动和问题对工作及交付成果的影响',
  solutionRow37: '杰为平台不断分析依赖性与关联性，复盘并输出优质建议，确保落实双管齐下的全部优势。',

  solutionRow38: '生产力提升和资源优化',
  solutionRow39: '更高的机器利用率，更快的产出，最少的报废',
  solutionRow40: '通过设备、人员与材料的二次配置，制造商可以迅速采取行动，应对生产计划的变化，获取竞争优势，改善公司形象，增加销售机会。',
  solutionRow41: '在当今互联互通的世界中，提高生产率意味着与机器和生产线的数字孪生协同作业，确保更高的机器利用率，达成更快的产出，实现最少的报废。',
  solutionRow42: '杰为工业软件使用实时数据对制造过程进行全方位跟踪测量及分析，脱离个人经验或建议的桎梏，实现更快更优决策。',
  solutionRow43: '识别质量、速度、设备模式和问题，改善质量与交付',
  solutionRow44: '配置物理设备或整个生产线的数字孪生，创建智能制造模型，优化生产活动',
  solutionRow45: '自动将优化的数据反馈给机器和生产线设备，确保生产进度达成计划要求，确保产品质量永远符合质量标准',
  solutionRow46: '除了轻松调整生产线以满足不断变化的需求外，杰为还可以帮助制造商避免因生产线变更、工程变更和其他场景而产生的常见质量和设备问题，以确保更高的机器利用率、更快的产出和最小的报废。',

  solutionRow47: '保证稳定一致的质量',
  solutionRow48: '自动预测修复供应链质量的问题',
  solutionRow49: '对于制造商而言，交付高质量无瑕疵的产品是客户满意度的标杆，极度影响客户忠诚度和业务成交率。但是，质量问题通常在量产质检中发现。手动操作既费时又迟缓，拖延生产效率，增加运行成本。',
  solutionRow50: '',
  solutionRow51: '杰为消除了传统质量管理过程中固有的不一致性和复杂性，使制造商能够自动监控和预测供应链中的所有质量事件，实现快速识别，即时响应。',
  solutionRow52: '全面了解供应链中的实时质量数据和趋势分析',
  solutionRow53: '预测整条供应链中可能的质量问题',
  solutionRow54: '及时纠错，将问题掐在苗头',
  solutionRow55: '杰为的数字化线链实现了智能化的“虚拟工厂”，在这种虚拟工厂中，整个供应链中的质量流程都得到持续性优化，缺陷、报废或返工等质量问题得以大幅减少。',

  solutionRow56: 'PLM&硬件&云的替换',
  solutionRow57: '替换遗留系统，具象现代化，加速数字转型',
  solutionRow58: '云、机器学习、人工智能和高级数据分析的爆炸式增长为工业软件带来了新意，数字化转型对于任何制造企业的发展都至关重要，但是那些在遗留PLM、运行技术、硬件等方面进行多年多年的企业，则需要克服系统带来的种种挑战，解决性能、扩展性和灵活性方面的问题。',
  solutionRow59: '数字化转型对于任何制造企业的发展都至关重要，但是那些在遗留PLM、运行技术、硬件等方面进行多年多年的企业，则需要克服系统带来的种种挑战，解决性能、扩展性和灵活性方面的问题。',
  solutionRow60: '杰为工业软件是采用最新技术构建而成的云原生平台，使客户能够以合适的节奏进行PLM系统、运营技术和硬件上的替换，全面数字化现代化',
  solutionRow61: '深挖现代架构、全球互联与工厂自动化的优势，有效重建技术堆栈',
  solutionRow62: '访问更多信息，了解深层分析与创新，输出更快更优决策',
  solutionRow63: '纵享全面数字化',
  solutionRow64: '杰为的软件极具现代化，种类多样，覆盖设计、研发、制造和质量，均可与现有系统同时运行。通过消除硬件及数据库的依赖行，无需中断即可轻松部署新应用。',

  solutionRow65: 'IT / OT融合',
  solutionRow66: '更快迁往全联接的智能工厂',
  solutionRow67: '将技术与IT系统中的数据组合，且无需进行复杂的点对点集成，这是现代化公司必备的能力。',
  solutionRow68: '调整集成IT及OT环境是工业 4.0和工业物联网的基石。但是，单一的遗留系统需要过于复杂的点对点集成，PLM尤其如此，也将导致公司错失良机，无法将珍贵的制造数据传输到可提供重要的业务创意及实时可视性的操作系统。',
  solutionRow69: '杰为基于云的本地化及基于微服务的体系结构可以全面监控OT及IT制造系统，从而实现机器、设备、流程和云服务器之间的直接沟通，每个组件都成为了单个集中式网络的组成部分。',
  solutionRow70: '将制造过程中的物理元素与用于交流及处理信息决策的后端系统无缝集成，软硬件均不例外',
  solutionRow71: '以更少的IT基础架构投资来部署新技术，进行新服务，安装新组件',
  solutionRow72: '使用杰为低代码平台开发自己的应用程序，完成特定任务与制造过程',
  solutionRow73: '杰为数字化链的智能连接意味着能够自动连接大量来自设备、流程和人员的数据，实时生成有建设性的意见，从而优化决策，提高透明度和敏捷性。'
}
